// extracted by mini-css-extract-plugin
export default {"heading":"PaymentOptions_heading__AN9wH","wrapper":"PaymentOptions_wrapper__CSGk1"};